module.exports = __webpack_public_path__ + "static/media/myZoneLogo.3a4d4283.svg";